<template>
  <aside
    :class="[
      'main-sidebar',
      'col-12',
      'col-md-3',
      'col-lg-2',
      'px-0',
      sidebarVisible ? 'open' : '',
    ]"
  >
    <div class="main-navbar logo">
      <nav
        class="p-0 navbar align-items-stretch navbar-light bg-primary flex-md-nowrap border-bottom"
      >
        <a
          class="mr-0 navbar-brand w-100 h-100"
          href="#"
          style="line-height: 25px"
        >
          <div class="m-auto text-center d-table">
            <img
              id="main-logo"
              class="mr-1 align-top d-inline-block"
              style="max-height: 26px; max-width: 80%"
              src="@/assets/images/logo-riffel.png"
              alt="Sistema de gerenciamento"
            />
          </div>
        </a>
        <a
          class="text-white toggle-sidebar d-sm-inline d-md-none d-lg-none"
          @click="handleToggleSidebar()"
        >
          <i class="material-icons">&#xE5C4;</i>
        </a>
      </nav>
    </div>

    <div class="nav-wrapper">
      <d-nav class="flex-column">
        <li
          v-for="(item, navItemIdx) in menu"
          :key="navItemIdx"
          class="nav-item dropdown"
        >
          <router-link
            :class="[
              'nav-link',
              item.items && item.items.length ? 'dropdown-toggle' : '',
            ]"
            :to="item.to"
            v-d-toggle="`snc-${navItemIdx}`"
          >
            <div
              class="item-icon-wrapper"
              v-if="item.htmlBefore"
              v-html="item.htmlBefore"
            />
            <span v-if="item.title">{{ item.title }}</span>
            <div
              class="item-icon-wrapper"
              v-if="item.htmlAfter"
              v-html="item.htmlAfter"
            />
          </router-link>
          <d-collapse
            v-if="item.items && item.items.length"
            :id="`snc-${navItemIdx}`"
            class="dropdown-menu dropdown-menu-small"
            accordion="sidebar-items-accordion"
          >
            <router-link
              class="dropdown-item nav-link"
              v-for="(subItem, subItemIdx) in submenu(item.items)"
              :key="subItemIdx"
              :to="subItem.to"
            >
              {{ subItem.title }}
            </router-link>
          </d-collapse>
        </li>
      </d-nav>
    </div>
  </aside>
</template>

<script>
import Config from '_config';
import Events from '_utils/events';
import SessionService from '_services/common/sessionService';
import { mapActions } from 'vuex';

export default {
  name: 'main-sidebar',
  props: {
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    menu() {
      return this.items.filter(item =>
        (this.modules.includes(item.name) || item.name === 'dashboard') &&
          this.checkAccess(item));
    },
    isReseller() {
      const { user } = this.$store.state.user;
      if (user && user.settings.user_type_id === Config.RESELLER_TYPE_ID) {
        return true;
      }
      return false;
    },
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  data() {
    return {
      sidebarVisible: false,
      modules: [],
    };
  },
  methods: {
    ...mapActions(['checkAdmin', 'getUserLocalStorage']),
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    submenu(items) {
      return items.filter(subItem => this.checkAccess(subItem));
    },
    checkAccess(item) {
      if (this.isAdmin && 'isAdmin' in item) {
        return item.isAdmin;
      }
      if (this.isReseller && 'isReseller' in item) {
        return item.isReseller;
      }
      return true;
    },
  },
  created() {
    const { modules } = SessionService.getLocalData('_user');
    this.getUserLocalStorage();
    this.checkAdmin();
    this.modules = modules.map(module => module.slug);
    this.$eventHub.$on('toggle-sidebar', this.handleToggleSidebar);
    Events.$on('sidebarVisible', sidebarVisible => {
      this.sidebarVisible = sidebarVisible;
    });
  },
  beforeDestroy() {
    this.$eventHub.$off('toggle-sidebar');
    Events.$off('sidebarVisible');
  },
};
</script>

<style lang="scss">
.main-sidebar {
  .item-icon-wrapper {
    display: inline-block;
  }
  .dropdown-menu {
    display: block;
  }
}
</style>
